<!-- 延迟客服消息 -->
<template>
  <div style="position: relative">
    <div style="display: flex; align-items: center; margin-bottom: 10px">
      <a-button
        class="screen-box"
        style="margin-bottom: 0"
        @click="addShowModal()"
        type="primary"
        icon="plus"
        >新建延迟客服消息</a-button
      >
      <div>
        提示：支持用户关注后6小时内首次发送消息后48小时内推送客服消息，最多设置5条。
      </div>
    </div>

    <!-- 表头 -->
    <div
      class="table-th"
      :style="{ width: configTable_width + 'px' }"
      style="top: 0"
    >
      <div v-for="(item, index) in configTable" :key="index">
        <div class="table-th-cell" :style="{ width: item.width + 'px' }">
          {{ item.title }}
        </div>
      </div>
    </div>

    <div
      v-for="(item, index) in configData"
      :key="item.id"
      class="table-td"
      :style="{ width: configTable_width + 'px' }"
    >
      <template v-for="(z_tem, z_ndex) in configTable">
        <div
          v-if="
            z_tem.type != 'content' &&
            z_tem.type != 'type' &&
            z_tem.type != 'status' &&
            z_tem.type != 'cz'
          "
          class="table-td-cell"
          :style="{ width: configTable[z_ndex].width + 'px' }"
        >
          {{ item[z_tem.type] }}
        </div>
        <div
          v-else-if="z_tem.type == 'content'"
          class="table-td-cell"
          :style="{ width: configTable[z_ndex].width + 'px' }"
        >
          <a-popover v-if="item.type != 4" placement="right">
            <template slot="content">
              <template v-if="item.type == 2">
                <img
                  :src="item.content.media_id_url"
                  style="max-width: 220px"
                  alt=""
                />
              </template>
              <template v-else-if="item.type == 3">
                <div
                  style="
                    width: 220px;
                    box-shadow: 0 0 3px 3px #f7f7f7;
                    padding: 10px;
                  "
                >
                  <div style="font-weight: 600">{{ item.content.title }}</div>
                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      margin-top: 3px;
                    "
                  >
                    <div style="font-size: 13px; color: #999">
                      {{ item.content.description }}
                    </div>
                    <img
                      :src="item.content.image"
                      style="width: 50px; height: 50px; object-fit: cover"
                      alt=""
                    />
                  </div>
                </div>
                <div style="margin-top: 10px; width: 220px">
                  跳转地址：<a
                    :href="item.content.url"
                    style="word-break: break-all"
                    >{{ item.content.url }}</a
                  >
                </div>
              </template>
              <template v-else-if="item.type == 1">
                <pre
                  v-html="item.content.content"
                  style="margin-bottom: 0; max-width: 300px"
                ></pre>
              </template>
              <template v-else-if="item.type == 5">
                <div>
                  <div
                    style="margin-bottom: 5px; font-size: 15px; width: 250px"
                  >
                    {{ item.content.title }}
                  </div>
                  <img
                    :src="item.content.thumb_media_id_url"
                    style="width: 250px; height: 200px"
                  />
                </div>
              </template>
            </template>
            <span
              @click="previewClick(item)"
              style="color: #62a8ea; cursor: pointer"
              >预览</span
            >
          </a-popover>
          <span v-else style="color: #62a8ea; cursor: pointer">预览</span>
        </div>
        <div
          v-else-if="z_tem.type == 'type'"
          class="table-td-cell"
          :style="{ width: configTable[z_ndex].width + 'px' }"
        >
          {{ item[z_tem.type] | msgTypeFilters }}
        </div>
        <div
          v-else-if="z_tem.type == 'status'"
          class="table-td-cell"
          :style="{ width: configTable[z_ndex].width + 'px' }"
        >
          <a-switch
            :checked="item.status_switch"
            :loading="item.switch_loading"
            checked-children="开启"
            un-checked-children="关闭"
            @change="onStatusChange($event, item)"
          />
        </div>
        <div
          v-else-if="z_tem.type == 'cz'"
          class="table-td-cell"
          :style="{ width: configTable[z_ndex].width + 'px' }"
          style="display: flex"
        >
          <div @click="drawerTdCz(1, item)" class="cz-cell">编辑</div>
          <!-- <div @click="drawerTdCz(2,item)" class="cz-cell" >预览</div> -->
          <div @click="drawerTdCz(3, item)" class="cz-cell" style="color: red">
            删除
          </div>
        </div>
      </template>
    </div>
    <!-- 表格内容为空时显示 -->
    <div
      v-show="configData.length == 0"
      style="text-align: center; text-align: center; padding: 30px 0 30px"
      :style="{ width: configTable_width + 'px' }"
    >
      <a-icon style="font-size: 70px; color: #999" type="file-search" />
      <div style="color: #999; font-size: 16px; margin-top: 20px">内容为空</div>
    </div>
    <!-- 分页 -->
    <pagingCompont
      :table_scroll_width="configTable_width"
      :table_null_width="configTable_width"
      :r_page="config_page"
      :r_limit="config_limit"
      :table_total="config_total"
      @pagination-Change="paginationConfig"
      @change-size-limit="pageSizeChange"
    ></pagingCompont>

    <div
      style="
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 9;
      "
      v-show="drawer_search_loading"
    >
      <a-spin size="large" />
    </div>

    <keywordReplyModal
      :set_type="set_type"
      ref="getMsgModal"
      :config_id="config_id"
      :msg_channel_id="msg_channel_id"
      :msg_channel_name="msg_channel_name"
      :edit_id="edit_id"
      :handle_title="handle_title"
      @handle-success="msgModalOK"
      page_type="contact"
    ></keywordReplyModal>

    <!-- 加载中 -->
    <div class="loading-box" v-if="search_button_loading">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import keywordReplyModal from "./keywordReplyModal.vue";
import {
  gzhContactList,
  gzhContactAdd,
  gzhContactEdit,
  gzhContactDel,
  gzhContactStatus,
} from "@/request/api";
export default {
  name: "pageContactMsg_",
  props: ["set_type"],
  components: {
    keywordReplyModal,
  },
  data() {
    return {
      search_button_loading: false,

      configTable: [
        // 推送统计
        { title: "消息ID", width: 90, type: "id", text_right: false },
        { title: "消息名称", width: 180, type: "title", text_right: false },
        { title: "消息内容", width: 130, type: "content", text_right: false },
        { title: "消息类型", width: 130, type: "type", text_right: false },
        {
          title: "推送时机",
          width: 150,
          type: "delay_text",
          text_right: false,
        },
        { title: "开启状态", width: 100, type: "status", text_right: false },
        { title: "操作", width: 150, type: "cz", text_right: false },
      ],
      configTable_width: 1000, // 表格宽度
      configData: [],
      config_page: 1,
      config_limit: 8,
      config_total: 0,
      config_id: null, // 点击的表格内的公众号id
      configSelect: [], // 用于下拉框的数据

      drawer_content_type: "1",
      drawer_search_loading: false,

      gzhTabData: [], // 新建消息组件里的公众号tab
      msg_channel_id: 0,
      msg_channel_name: "",

      edit_id: null,
      handle_title: "新建",

      visibleData: false,
    };
  },
  mounted() {
    let that = this;

    // 获取页面可视宽度
    let body_width = document.body.clientWidth - 60 - 212 - 20 - 30 * 2 - 50;
    let fff = 0;
    that.configTable.forEach((res) => {
      fff = fff + res.width;
    });
    // 适配处理
    that.configTable.forEach((res) => {
      res.width = Math.round((res.width / fff) * body_width);
    });
    that.configTable_width = body_width;
  },
  methods: {
    // 表格内的操作
    wxTdCz(item) {
      console.log("item", item);
      let that = this;

      let obj = {
        gzh_name: item.gzh_name,
        id: item.id,
        select_status: true,
        contentData: {}, // 这里写上，contentData里的数据就会是响应式的
      };
      let arr = [];
      arr.push(obj);
      that.gzhTabData = arr;

      that.msg_channel_id = item.channel_id;
      that.msg_channel_name = item.channel_name;

      that.config_id = item.id;
      that.configSearch();
    },
    // 切换状态
    onStatusChange(e, item) {
      item.switch_loading = true;
      gzhContactStatus({
        id: item.id,
        content_type: this.set_type === "h5" ? 1 : 2,
      })
        .then((res) => {
          console.log("切换状态", res);
          item.switch_loading = false;
          if (res.data.code == 0 || res.data.code == 200) {
            item.status_switch = e;
            item.status = e ? 1 : 0;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              this.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              this.$message.error(`错误：${res.data.msg}`);
            }
          }
        })
        .catch((err) => {
          item.switch_loading = false;
          this.$message.error(`网络错误请重试`);
        });
    },
    // 侧边栏表格的操作
    drawerTdCz(e, item) {
      let that = this;
      console.log(e, item);
      if (e == 1) {
        // 编辑
        this.$refs.getMsgModal.editModal(item, this.gzhTabData);
        that.handle_title = "编辑";
      } else if (e == 2) {
        // 预览
        this.$refs.getMsgModal.editModal(item, this.gzhTabData);
        that.handle_title = "预览";
      } else if (e == 3) {
        // 删除
        this.$confirm({
          title: "确定要删除吗?",
          content: `消息名称：${item.title}`,
          okText: "删除",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            gzhContactDel({
              id: item.id,
            }).then((res) => {
              console.log("删除", res);
              if (res.data.code == 0) {
                that.$message.success("删除成功");
                that.configSearch();
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          },
          onCancel() {
            console.log("Cancel");
          },
        });
      }
    },
    paginationConfig(e) {
      this.config_page = e;
      this.configSearch();
    },
    pageSizeChange(e) {
      this.config_limit = e;
      this.configSearch();
    },
    // 关注后回复的消息列表
    configSearch() {
      let that = this;
      that.search_button_loading = true;
      // 关注后回复的消息列表
      gzhContactList({
        gzh_id: that.config_id,
        page: that.config_page,
        limit: that.config_limit,
        content_type: that.set_type === "h5" ? 1 : 2,
      })
        .then((res) => {
          console.log("关注后回复的消息列表", res);
          that.search_button_loading = false;
          if (
            res.data.code == 0 ||
            res.data.code == 200 ||
            res.data.code == 8011
          ) {
            // that.$message.success('搜索成功');
            let data = res.data.data.data;
            data.forEach((res) => {
              res.delay_text = "用户互动后" + res.send_time + "分钟";

              if (res.status == 1) {
                // 开启
                res.status_switch = true;
              } else {
                res.status_switch = false;
              }
              res.switch_loading = false;
            });
            that.configData = res.data.data.data;
            that.config_total = res.data.data.total;
            that.visibleData = true;
          } else {
            if (res.data.code == 401) {
              // 未登录
              localStorage.removeItem("access_token");
              that.$router.replace({
                name: "login",
                params: { type: "not_log" },
              });
            } else {
              that.$message.error(`错误：${res.data.msg}`);
            }
          }
        })
        .catch((err) => {
          that.search_button_loading = false;
          that.$message.error(`网络错误请重试`);
        });
    },

    // 新建消息按钮
    addShowModal() {
      // if(this.gzhTabData.length>5){
      //   this.$message.warning(`用户关注后6小时内首次发送消息后48小时内推送客服消息，最多设置5条`);
      //   return
      // }
      this.handle_title = "新建";
      // this.msg_modal_visible = true
      this.$refs.getMsgModal.showModal(this.gzhTabData);
    },
    // 新增编辑请求成功后
    msgModalOK() {
      this.configSearch();
    },

    previewClick(item) {
      console.log("item", item);
    },
  },
  filters: {
    msgTypeFilters(value) {
      let vvv = "";
      if (value == 1) {
        vvv = "文本";
      } else if (value == 2) {
        vvv = "图片消息";
      } else if (value == 3) {
        vvv = "单条图文消息";
      } else if (value == 4) {
        vvv = "多条图文消息";
      } else if (value == 5) {
        vvv = "小程序卡片消息";
      }
      return vvv;
    },
  },
};
</script>

<style scoped>
/* 表格内的操作按钮 */
.cz-cell {
  color: #62a8ea;
  cursor: pointer;
  margin-right: 12px;
  /* margin-bottom: 5px; */
}
.cz-cell:hover {
  color: rgb(47, 136, 255);
}
</style>
